import React from "react";
import { Stack, Text } from "@mantine/core";
import CustomTooltip from "./CustomTooltip";

interface InputLabelProps {
  label: string;
  tooltip?: string;
  textStyle?: React.CSSProperties;
}

const InputLabel: React.FC<InputLabelProps> = ({
  label,
  tooltip,
  textStyle,
}) => (
  <Stack style={{ flexDirection: "row" }} align="center" spacing={4}>
    <Text style={{ ...textStyle }}>{label}</Text>
    {tooltip && <CustomTooltip label={tooltip} />}
  </Stack>
);

export default InputLabel;
